<template>
  <div
    id="right-srcoll"
    class="scroll-wrapper beauty-scroll"
    @scroll="scrollEvent"
  >
    <!-- 文件动态及查看详情 -->
    <file-dynamic ref="fileDynamic"></file-dynamic>
    <div class="properties-body">
      <div class="properties-title">
        <span>{{ $t('文件属性') }}</span>
      </div>
      <file-info
        class="file-content"
      >
      </file-info>
    </div>
  </div>
</template>

<script>
import fileDynamic from 'components/old/rpanel/detail/file-dynamic/file-dynamic.vue'
import fileInfo from './rpanel-fileinfo.vue'

export default {
  components: {
    fileDynamic,
    fileInfo,
  },
  methods: {
    scrollEvent() {
      this.$refs.fileDynamic.hideDateMenu()
    },
  },
}
</script>

<style lang="less" scoped>
    .scroll-wrapper {
        padding: 0 24px;
        .file-content {
            height: auto;
            overflow: inherit;
            padding: 0;
        }
        .properties-title {
            height: 30px;
            line-height: 30px;
            border-bottom: 1px solid #e8ebef;
        }
        height: 100%;
        // 增加右侧栏历史版本时，要内层元素充满父元素
        width: 100%;
        box-sizing: border-box;
    }
</style>
